import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="w-full bg-navy-medium py-16 md:py-24 px-4" data-id="element-140">
      <div className="max-w-4xl mx-auto text-center" data-id="element-141">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-142">
          <p className="font-body text-lg md:text-xl text-gray-300 mb-8 leading-relaxed" data-id="element-143">
            Te lo dijeron mil veces: "Va a ser difícil". Pero nadie te explicó
            qué tan difícil sería hacerlo aquí, en Estados Unidos.
          </p>
          <p className="font-body text-lg md:text-xl text-gray-300 mb-8 leading-relaxed" data-id="element-144">
            Trabajas 8, 10 o 12 horas. Llegas a casa y la tensión se corta con
            un cuchillo. Tu pareja está agotada, el bebé no deja de llorar, y en
            el fondo de tu mente solo hay una pregunta que te quita el sueño más
            que los pañales:
          </p>
          <p className="font-body text-2xl md:text-3xl text-gold italic mb-12 leading-relaxed" data-id="element-145">
            "¿Estoy haciendo lo suficiente? ¿Qué pasa si mañana algo sale mal?"
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="mt-16" data-id="element-146">
          <h2 className="font-heading text-3xl md:text-4xl text-white mb-6" data-id="element-147">
            El Problema que Nadie Te Cuenta
          </h2>
          <p className="font-body text-lg md:text-xl text-gray-300 leading-relaxed" data-id="element-148">
            La mayoría de los libros de paternidad son "románticos". Hablan de
            sentimientos y conexión, pero no te dicen cómo navegar un seguro
            médico que parece estafa, cómo ahorrar para la universidad en
            dólares cuando la renta sube, o cómo ser el apoyo de tu esposa
            cuando tú mismo sientes que vas a explotar.
          </p>
        </motion.div>
      </div>
    </section>;
}